import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { otherDeductionsDetailInputList4 } from '../../../common/data';

import ItemTitleSection from '../../../components/ItemTitleSection';
import InputItemSection from './OtherInputItemSection';
import { formatNumber, getTotal } from '../../../common/Util';
import Radio from '../../../components/common/Radio';
import Typography from '../../../components/common/Typography';
import Chips from '../../../components/common/Chips';
import TextField from '../../../components/common/TextField';

// 우리사주 소기업, 소상공인
const Type4 = ({ handleAddButton }) => {
  const { t } = useTranslation('deductions/other');
  const { t: tCommon } = useTranslation('common');
  const inputList = otherDeductionsDetailInputList4(t);
  const { s11_4Data } = useSelector(state => state.otherDeductions);
  const [dataList, setDataList] = useState({});

  const total = useMemo(() => {
    return getTotal([s11_4Data], ['htm017', 'htm048', 'htm053', 'htm171', 'htm172', 'htm143']);
  }, [s11_4Data]);

  useEffect(() => {
    const { htmVentureFlag } = s11_4Data;
    let htm175 = s11_4Data.htm175 || '';
    if (htmVentureFlag != undefined) {
      htm175 = htmVentureFlag;
    }

    setDataList({
      htm017: s11_4Data.htm017,
      htm048: s11_4Data.htm048,
      htm053: s11_4Data.htm053,
      htm143: s11_4Data.htm143,
      htm171: s11_4Data.htm171 || '',
      htm172: s11_4Data.htm172 || '',
      htm173: s11_4Data.htm173 || '',
      htm175: htm175,
      htm180: s11_4Data.htm180 || '',
      htm181: s11_4Data.htm181 || '',
    });
  }, [s11_4Data]);

  return Number(total) > 0 ? (
    <div className="displayFlexColumn" style={{ gap: '16px' }}>
      <ItemTitleSection
        title={t('detail.type4.title')}
        addButton={true}
        handleAddButton={handleAddButton}
      />
      <Typography variant="body2Medium">{t('detail.type4.radioTitle1')}</Typography>
      <Typography variant="body2Medium">{t('detail.type4.radioTitle2')}</Typography>
      <div className="displayFlex" style={{ gap: '40px', justifyContent: 'flex-end' }}>
        <Radio
          label={tCommon('radioGroup.yes')}
          size="medium"
          checked={dataList.htm175 == '1'}
          value="1"
          onChange={() => {}}
        />
        <Radio
          label={tCommon('radioGroup.no')}
          size="medium"
          checked={dataList.htm175 == '' || dataList.htm175 == '2'}
          value=""
          onChange={() => {}}
        />
      </div>
      {/* 우리사주조합 출연금 */}
      <TextField
        size="small"
        label={t('detail.type4.inputLabel1') + t('detail.type4.inputLabel6')}
        value={formatNumber(dataList.htm017)}
        onChange={() => {}}
        disabled={true}
      />
      <TextField
        size="small"
        label={t('detail.type4.inputLabel1') + t('detail.type4.inputLabel7')}
        value={formatNumber(dataList.htm181)}
        onChange={() => {}}
        disabled={true}
        // disabled
      />
      <Typography variant="body2Medium" style={{ whiteSpace: 'pre-wrap' }}>
        {t('detail.type4.radioLabel3')}
      </Typography>
      <div className="displayFlex" style={{ gap: '40px', justifyContent: 'flex-end' }}>
        <Radio
          label={tCommon('radioGroup.yes')}
          size="medium"
          checked={dataList.htm173 == '1'}
          value="1"
          onChange={() => {}}
        />
        <Radio
          label={tCommon('radioGroup.no')}
          size="medium"
          checked={dataList.htm173 != '1'}
          value=""
          onChange={() => {}}
        />
      </div>
      <InputItemSection
        dataList={dataList}
        inputList={inputList}
        disabled={true}
        addButton={true}
      />
      {/* 지역건강보험 */}
      <Typography variant="body2Medium">{t('detail.type4.inputLabel4')}</Typography>
      <Chips color="warning">{t('detail.type4.chips')}</Chips>
      <TextField
        size="small"
        value={formatNumber(dataList.htm143)}
        onChange={() => {}}
        disabled={true}
      />
      {/* 국민연금 지역가입자 */}
      <Typography variant="body2Medium">{t('detail.type4.inputLabel5')}</Typography>
      <TextField size="small" value={formatNumber(dataList.htm180)} name="htm180" disabled />
    </div>
  ) : (
    <></>
  );
};

export default Type4;
